import { combineReducers } from "@reduxjs/toolkit";
import state from "./stateSlice";
import data from "./dataSlice";

const RawMaterialreducer = combineReducers({
  state,
  data,
});

export default RawMaterialreducer;